<template>
  <div class="lxn-w100">
    <div class="TvRemoteController-wrapper-remote lxn-margin-auto">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 335 500" style="enable-background:new 0 0 335 500;" xml:space="preserve">
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#333333;" d="M73.4,0h187.7c20.9,0,34.3,9.9,38.1,22.1
        c53.7,177.5,40.7,355,0,451.2c-15.1,35.7-247.4,35.4-263.6-0.1c-40.7-88.5-53.7-273.6,0-451.1C39.1,10.1,52.5,0,73.4,0L73.4,0z"/>
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#1A1A1A;" d="M171.9,339.1l10.9,10.9l-2,2l-8.9-8.9L163,352l-2-2L171.9,339.1
        z M171.9,471.9l10.9-10.9l-2-2l-8.9,8.9L163,459l-2,2L171.9,471.9z"/>
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#1A1A1A;" d="M105.7,405.5l10.9-10.9l2,2l-8.9,8.9l8.9,8.9l-2,2L105.7,405.5z
        M238.3,405.5l-10.9-10.9l-2,2l8.9,8.9l-8.9,8.9l2,2L238.3,405.5z"/>
      <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" d="M167.1,325c42.4,0,76.8,34.3,76.8,76.8s-34.5,76.8-76.8,76.8
        s-76.7-34.5-76.7-76.8S124.7,325,167.1,325L167.1,325z M167.1,356.5c25,0,45.3,20.3,45.3,45.3c0,25.1-20.2,45.3-45.3,45.3
        c-25,0-45.3-20.3-45.3-45.3S142.1,356.5,167.1,356.5L167.1,356.5z"/>
      <g>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" d="M167.1,363.4c21.2,0,38.3,17.2,38.3,38.4s-17.1,38.4-38.3,38.4
          s-38.3-17.2-38.3-38.4S145.9,363.4,167.1,363.4L167.1,363.4z"/>
      </g>
      <path style="fill:#1D71AA;" d="M89.9,279.6H73.4c-14.4,0-26.1-11.7-26.1-26.1V135.6c0-14.4,11.7-26.1,26.1-26.1h16.5
        c14.4,0,26.1,11.7,26.1,26.1v117.8C116.1,267.8,104.5,279.6,89.9,279.6z"/>
      <polygon style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;" points="65.7,203 99.1,203 99.1,185.6 "/>
      <path style="fill:#079950;" d="M264.7,280.1h-16.5c-14.4,0-26.1-11.7-26.1-26.1V134.4c0-14.4,11.7-26.1,26.1-26.1h16.5
        c14.4,0,26.1,11.7,26.1,26.1V254C290.8,268.5,279.1,280.1,264.7,280.1z"/>
      <g>
        <g style="enable-background:new    ;">
          <path style="fill:#FFFFFF;" d="M246.9,209.9v-35.7h13.5c2.4,0,4.2,0.1,5.4,0.3c1.8,0.3,3.2,0.9,4.4,1.7c1.2,0.8,2.1,2,2.9,3.4
            c0.7,1.5,1.1,3.1,1.1,4.9c0,3-1,5.6-2.9,7.7s-5.4,3.1-10.5,3.1h-9.1v14.5L246.9,209.9L246.9,209.9z M251.6,191.2h9.2
            c3,0,5.2-0.6,6.5-1.7c1.3-1.1,1.9-2.7,1.9-4.8c0-1.5-0.4-2.8-1.1-3.8s-1.8-1.8-3-2.1c-0.8-0.2-2.3-0.3-4.4-0.3h-9.1V191.2z"/>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_POWER')">
        <g>
          <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#FF6666;" d="M84.3,17.3c18.2,0,32.9,14.7,32.9,32.9s-14.9,33.1-32.9,33.1
            c-18.2,0-32.9-14.7-32.9-33.1C51.4,32,66.1,17.3,84.3,17.3L84.3,17.3z"/>
        </g>
        <g>
          <g>
            <path style="fill:#FFFFFF;" d="M77.7,37.5c0.9,0,1.8,0.5,2.2,1.3c0.7,1.2,0.3,2.8-0.9,3.5c-3.2,1.9-5.3,5.4-5.3,9.1
              c0,5.8,4.7,10.6,10.6,10.6s10.6-4.7,10.6-10.6c0-3.7-1.8-7-4.9-8.9c-1.2-0.8-1.6-2.4-0.8-3.6c0.8-1.2,2.4-1.6,3.6-0.8
              c4.6,2.9,7.3,7.9,7.3,13.3c0,8.7-7.1,15.7-15.8,15.7S68.5,60,68.5,51.3c0-5.6,3-10.8,7.8-13.6C76.8,37.6,77.3,37.5,77.7,37.5z"/>
          </g>
          <g>
            <path style="fill:#FFFFFF;" d="M84.3,33.4c1.4,0,2.6,1.2,2.6,2.6v11.9c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6V36
              C81.8,34.6,82.9,33.4,84.3,33.4z"/>
          </g>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_SOURCE')">
        <path style="fill:#666666;" d="M258.8,69.2h-64.3c-3.8,0-6.8-3-6.8-6.8V42.8c0-3.8,3-6.8,6.8-6.8h64.3c3.8,0,6.8,3,6.8,6.8v19.6
          C265.5,66.2,262.5,69.2,258.8,69.2z"/>
        <g>
          <path style="fill:#FFFFFF;" d="M201.9,56.5c0.7,0.4,1.8,0.8,2.8,0.8c1.6,0,2.6-0.9,2.6-2.1c0-1.2-0.7-1.8-2.3-2.4
            c-2-0.7-3.2-1.8-3.2-3.5c0-1.9,1.6-3.3,4-3.3c1.3,0,2.2,0.3,2.7,0.6l-0.4,1.3c-0.4-0.2-1.2-0.6-2.3-0.6c-1.7,0-2.3,1-2.3,1.8
            c0,1.2,0.8,1.7,2.4,2.4c2.1,0.8,3.1,1.8,3.1,3.6c0,1.9-1.4,3.5-4.3,3.5c-1.2,0-2.5-0.3-3.1-0.8L201.9,56.5z"/>
          <path style="fill:#FFFFFF;" d="M219.1,54c0,3.3-2.3,4.7-4.4,4.7c-2.4,0-4.2-1.8-4.2-4.5c0-3,1.9-4.7,4.4-4.7
            C217.4,49.4,219.1,51.3,219.1,54z M212.1,54.1c0,1.9,1.1,3.4,2.7,3.4c1.5,0,2.7-1.4,2.7-3.4c0-1.5-0.8-3.4-2.6-3.4
            C213,50.6,212.1,52.4,212.1,54.1z"/>
          <path style="fill:#FFFFFF;" d="M228.5,56c0,0.9,0,1.7,0.1,2.4h-1.4l-0.1-1.4l0,0c-0.4,0.7-1.4,1.6-2.9,1.6c-1.4,0-3-0.8-3-3.9
            v-5.2h1.6v4.9c0,1.7,0.5,2.8,2,2.8c1.1,0,1.8-0.8,2.1-1.5c0.1-0.2,0.1-0.5,0.1-0.8v-5.4h1.6L228.5,56L228.5,56z"/>
          <path style="fill:#FFFFFF;" d="M231.2,52.4c0-1,0-1.9-0.1-2.8h1.4l0.1,1.7h0.1c0.4-1.2,1.4-1.9,2.4-1.9c0.2,0,0.3,0,0.5,0V51
            c-0.2,0-0.3,0-0.6,0c-1.1,0-1.9,0.9-2.1,2.1c0,0.2-0.1,0.5-0.1,0.8v4.7h-1.6L231.2,52.4L231.2,52.4z"/>
          <path style="fill:#FFFFFF;" d="M243.2,58.1c-0.4,0.2-1.4,0.5-2.5,0.5c-2.7,0-4.4-1.8-4.4-4.5s1.9-4.7,4.7-4.7
            c0.9,0,1.8,0.2,2.2,0.5l-0.4,1.2c-0.4-0.2-1-0.4-1.9-0.4c-2,0-3.1,1.5-3.1,3.3c0,2,1.3,3.3,3.1,3.3c0.9,0,1.5-0.2,2-0.4
            L243.2,58.1z"/>
          <path style="fill:#FFFFFF;" d="M245.9,54.3c0,2.2,1.4,3.1,3,3.1c1.1,0,1.8-0.2,2.4-0.5l0.3,1.2c-0.6,0.2-1.5,0.5-2.9,0.5
            c-2.7,0-4.3-1.8-4.3-4.4s1.6-4.8,4.1-4.8c2.9,0,3.6,2.5,3.6,4.2c0,0.3,0,0.6-0.1,0.8L245.9,54.3L245.9,54.3z M250.6,53.2
            c0-1-0.4-2.6-2.2-2.6c-1.6,0-2.3,1.5-2.5,2.6H250.6z"/>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_MUTE')">
        <path style="fill:#666666;" d="M179.3,213.3h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C189.3,208.8,184.8,213.3,179.3,213.3z"/>
        <g>
          <g>
            <path style="fill:#FFFFFF;" d="M169.6,196.5l2.7-4L170,189c-0.2-0.3-0.4-0.6-0.5-0.9c-0.1-0.2-0.2-0.5-0.2-0.7s0.1-0.4,0.3-0.6
              c0.2-0.2,0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3s0.5,0.6,0.8,1.1l1.8,3l1.9-3c0.2-0.2,0.3-0.5,0.4-0.6s0.2-0.3,0.3-0.4s0.2-0.2,0.4-0.3
              s0.3-0.1,0.4-0.1c0.3,0,0.6,0.1,0.8,0.3s0.3,0.4,0.3,0.7c0,0.4-0.2,0.9-0.6,1.5l-2.4,3.6l2.6,4c0.2,0.4,0.4,0.6,0.5,0.9
              c0.1,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.1,0.5s-0.2,0.3-0.4,0.4c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4-0.1-0.6-0.1
              c-0.2-0.1-0.3-0.2-0.4-0.4s-0.3-0.4-0.6-0.8l-2.1-3.4l-2.3,3.5c-0.2,0.3-0.3,0.5-0.4,0.6c-0.1,0.1-0.2,0.2-0.3,0.3
              s-0.2,0.2-0.4,0.2s-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.8C169,197.6,169.2,197.1,169.6,196.5z"/>
          </g>
          <rect x="159.3" y="189.3" style="fill:#FFFFFF;" width="2.6" height="7"/>
          <polygon style="fill:#FFFFFF;" points="168.3,199.4 161.8,196.3 161.8,189.3 168.3,186.2 		"/>
        </g>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_MENU')">
        <path style="fill:#666666;" d="M87.6,335.3h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C97.6,330.8,93.2,335.3,87.6,335.3z"/>
        <path style="fill:#FFFFFF;" d="M89.3,316.9H65.5c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h23.8c0.6,0,1.1,0.5,1.1,1.1
          S89.9,316.9,89.3,316.9z"/>
        <path style="fill:#FFFFFF;" d="M89.3,308.6H65.5c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h23.8c0.6,0,1.1,0.5,1.1,1.1
          S89.9,308.6,89.3,308.6z"/>
        <path style="fill:#FFFFFF;" d="M89.3,325.2H65.5c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h23.8c0.6,0,1.1,0.5,1.1,1.1
          S89.9,325.2,89.3,325.2z"/>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_BACK')">
        <path style="fill:#666666;" d="M265.6,338.1h-21c-5.5,0-10-4.5-10-10v-21c0-5.5,4.5-10,10-10h21c5.5,0,10,4.5,10,10v21
          C275.6,333.6,271.1,338.1,265.6,338.1z"/>
        <path style="fill:#FFFFFF;" d="M262.5,311.2h-16.7l3.4-3.8c0.5-0.5,0.5-1.4,0-1.9s-1.3-0.5-1.7,0l-5.5,6.1c-0.5,0.5-0.5,1.4,0,1.9
          l5.5,6.1c0.2,0.3,0.6,0.4,0.9,0.4s0.6-0.1,0.9-0.4c0.5-0.5,0.5-1.4,0-1.9l-3.4-3.8h16.7c2.7,0,4.8,2.4,4.8,5.3s-2.2,5.3-4.8,5.3
          h-10.2c-0.7,0-1.2,0.6-1.2,1.4s0.6,1.4,1.2,1.4h10.2c4,0,7.3-3.6,7.3-8C269.8,314.8,266.5,311.2,262.5,311.2z"/>
      </g>
      <path style="fill:#079950;" class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELUP')" d="M290.5,160h-68.2v-24.3c0-14.9,12.1-27,27-27h14.2c14.9,0,27,12.1,27,27V160z"/>
      <polyline class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELUP')" style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;" points="244.7,134.4 255.3,121.5 265.6,134.4 "/>
      <path style="fill:#079950;" class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELDOWN')" d="M266.1,279.8h-19.5c-13.4,0-24.3-10.9-24.3-24.3v-27h68.2v27C290.5,268.9,279.6,279.8,266.1,279.8z"
        />
      <polyline class="lxn-cursor-pointer" @click="buttonClicked('KEY_CHANNELDOWN')" style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;" points="265.6,252.2 255.2,265.2 244.7,252.2 "/>
      <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEUP')" style="fill:#1D71AA;" d="M115.8,160H47.6v-24.3c0-14.9,12.1-27,27-27h14.2c14.9,0,27,12.1,27,27
        C115.8,135.7,115.8,160,115.8,160z"/>
      <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEDOWN')" style="fill:#1D71AA;" d="M91.4,278.8H71.9c-13.4,0-24.3-10.9-24.3-24.3v-27h68.2v27C115.8,267.9,104.9,278.8,91.4,278.8z"/>
      <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEUP')" style="fill:#FFFFFF;" d="M85.1,120.7v12h11.4v5.2H85.1V150h-5.4v-12.2H68.2v-5.2h11.4v-12L85.1,120.7L85.1,120.7z"/>
      <path class="lxn-cursor-pointer" @click="buttonClicked('KEY_VOLUMEDOWN')" style="fill:#FFFFFF;" d="M93.1,254.9v5.5H71.9v-5.5H93.1L93.1,254.9z"/>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_OK')">
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" d="M167.5,370.7c16.3,0,29.5,13.3,29.5,29.6
          c0,16.3-13.2,29.6-29.5,29.6S138,416.7,138,400.3C138,384,151.2,370.7,167.5,370.7L167.5,370.7z"/>
      </g>
      <g class="lxn-cursor-pointer" @click="buttonClicked('KEY_OK')">
        <path style="fill:#FFFFFF;" d="M167.3,402.2c0,4.2-2.6,6.5-5.7,6.5c-3.2,0-5.5-2.5-5.5-6.2c0-3.9,2.4-6.4,5.7-6.4
          C165.1,396,167.3,398.6,167.3,402.2z M157.7,402.4c0,2.6,1.4,5,3.9,5s3.9-2.3,3.9-5.1c0-2.4-1.3-5-3.9-5
          C159.1,397.3,157.7,399.7,157.7,402.4z"/>
        <path style="fill:#FFFFFF;" d="M169.3,396.2h1.6v5.9h0.1c0.3-0.5,0.7-0.9,1-1.3l3.8-4.6h2l-4.4,5.2l4.8,7.1h-1.9l-4-6l-1.2,1.4v4.7
          h-1.6L169.3,396.2L169.3,396.2z"/>
      </g>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_RIGHT')" x="212.4" y="384.1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="32.4"/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_RIGHT')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="232.4,400.3 221.6,389.5 219.6,391.4 228.5,400.3 
        219.6,409.2 221.6,411.2 "/>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_UP')" x="153.5" y="327.1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="29.4"/>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_LEFT')" x="92.5" y="384.1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="32.4"/>
      <rect class="lxn-cursor-pointer" @click="buttonClicked('KEY_DOWN')" x="155.8" y="447.6" style="fill-rule:evenodd;clip-rule:evenodd;fill:#666666;" width="29.1" height="29.1"/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_UP')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="168,337.9 178.9,348.8 176.9,350.8 168,341.9 
        159.1,350.8 157.1,348.8 "/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_LEFT')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="100.6,400.3 111.4,389.5 113.4,391.4 104.5,400.3 
        113.4,409.2 111.4,411.2 "/>
      <polygon class="lxn-cursor-pointer" @click="buttonClicked('KEY_DOWN')" style="fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;" points="170,467.8 180.9,456.9 178.9,454.9 170,463.8 
        161.1,454.9 159.1,456.9 "/>
      </svg>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'TvRemoteController',
  props: {
    nodeUUID: Number,
    outputIndex: Number,
    sendCommand: Boolean,
  },
  data: function() {
    return {
      node: this.$store.getters.getNodeByUUID(this.nodeUUID),
      targetCommandIndex: -1,
      commandSetTimeoutHandle: -1,
      debounceDelay: 0,
    }
  },
  components: {
    ButtonIcon
  },
  mounted: function () {
  },
  watch: {
    nodeUUID: function (newVal) {
      this.node =this.$store.getters.getNodeByUUID(newVal);
    },
    targetCommandIndex: function (newVal) {
      if(newVal == -1){
        return;
      }
      if(this.sendCommand){
        clearTimeout(this.commandSetTimeoutHandle);
        this.commandSetTimeoutHandle = setTimeout(function () {
          this.$store.commit('setAppBusy', true);
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE7.IR.PARAMETER_ID,
                      valueOfChange: messagingHook.utility.arrayTo128(this.irDevice.commands[newVal].command),
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    }
                  ]
                },
              ]
            }
          })
          .then( () => {
            console.log("Done");
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode == 1){
              this.$router.push('/SettingsNodeError');
            }else if(response.rejectCode == 2){
              this.$router.push('/SettingsHubError');
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          })
          .finally( () => {
            this.targetCommandIndex = -1;
          })
        }.bind(this), this.debounceDelay);
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    output: function () {
      return this.node.outputs[this.outputIndex];
    },
    irDevice: function () {
      var irDevice = NODE7.devices[this.output.settings.deviceType].brands[this.output.settings.brand].devices[this.output.settings.model];
      return irDevice;
    },
  },
  methods: {
    buttonClicked: function (button) {
      var commandIndex = this.irDevice.commands.findIndex( command => command.function == button);
      if(commandIndex != -1){
        this.targetCommandIndex = commandIndex;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .TvRemoteController-wrapper-remote {
    width: 90%;
  }
</style>
